<template>
  <div>
    ご指定の日時にご予約できる車両はありません。<br>
    別の日時をお選びください。
  </div>
</template>

<script>
export default {
  name: 'CNoBlock'
}
</script>
